import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';

import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit {
  loading: boolean;
  hide: boolean = true;
  tenant: string = '';
  loginForm: FormGroup;
  private readonly notifier: NotifierService;

  get loginFormControl() {
    return this.loginForm.controls;
  }

  get login(): any {
    const login = this.loginForm.value;
    return login;
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private readonly boobleModalService: BoobleModalService,
    private readonly authService: AuthenticationService,

  ) {
    this.notifier = notifierService;

    this.loginForm = fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    })

  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');
      if (result) this.tenant = params.get('tenant');
    });
  }

  goForgotPassword() {
    this.router.navigate([`${this.tenant}/admin/login/forgot-password`]);
  }

  addHours(numOfHours, date = new Date()) {
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

    return date.toISOString();
  }

  signIn() {
    this.loading = true;

    this.authService
      .authenticateAdmin(this.login)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          if (res.id_token) {
            this.loading = false;
            let date = new Date();
            let currentTokenExpiration = this.addHours(1, date);
            localStorage.setItem('token-expiresAt', currentTokenExpiration);
            this.router.navigate([`${this.tenant}/admin/home/1`]);

            this.authService.userData.partnerCode = this.tenant;
            this.authService.userData.key = res.id_token;
          }
        },
        () => {
          this.loading = false;
        }
      );
  }

}
